import calculateWrapOutside from '../calculateSize/calculateWrapOutside'

/*interface TargetObject {
    name: string;
    width: number;
    height: number;
}*/

interface MergeItem {
  width: number
  height: number
  x: number
  y: number
  name: string
  sectionId: string
  description: string
  mask?: File
}

interface WrapResult {
  x: number
  outOfBounds: number | false
}

import { createTargetObjectCanvas_CanvasItem_Props } from '@/types/productV2'

export default function mergeSections(name: string, sections: any[]) {
  const targetObject = sections.find((s) => s.targetObject?.name === name)?.targetObject
  if (!targetObject) return null

  const threeViewerTargetObject = (window as any).threeViewer.product.getObjectByName(name)
  if (!threeViewerTargetObject) return null

  const uvProjection = (window as any).threeViewer?.uvProjection || 'cylindrical'
  const isPlanarOrBox = uvProjection === 'planar' || uvProjection === 'box'

  const size = {
    width: Number(targetObject.width),
    height: Number(targetObject.height),
  }

  const frontItems: createTargetObjectCanvas_CanvasItem_Props[] = []
  const backItems: createTargetObjectCanvas_CanvasItem_Props[] = []

  sections
    .filter((s) => s.targetObject?.name === name && s.width && s.height)
    .forEach((s) => {
      const difBottom = threeViewerTargetObject.userData.bottomY * 1000
      const bottom = Number(targetObject.height) - (Number(s.offsetY) + Number(s.height) / 2) + difBottom

      if (isPlanarOrBox) {
        // For planar/box: face determined by radialAngle (0=front, 180=back)
        const isBack = Number(s.radialAngle) >= 90
        const sectionWidth = Number(s.width)
        const sectionHeight = Number(s.height)

        const obj: MergeItem = {
          x: (size.width - sectionWidth) / 2 + (Number(s.offsetX) || 0),
          y: bottom,
          name: s.name,
          sectionId: s.sectionId,
          description: isBack ? 'Back' : 'Section',
          width: sectionWidth,
          height: sectionHeight,
          mask: s.mask?.data,
        }

        if (isBack) {
          backItems.push(obj)
        } else {
          frontItems.push(obj)
        }
      } else {
        // Cylindrical/none: existing wrapping logic
        const offsetX = (size.width / 360) * Number(s.radialAngle) + (Number(s.offsetX) || 0)
        const sectionWidth = Number(s.width)
        const sectionHeight = Number(s.height)
        const { x, outOfBounds } = calculateWrapOutside(offsetX, sectionWidth, size.width) as WrapResult

        const obj: MergeItem = {
          x: x,
          y: bottom,
          name: s.name,
          sectionId: s.sectionId,
          description: sectionWidth === Number(targetObject.width) ? 'Full Wrap' : 'Section',
          width: sectionWidth,
          height: sectionHeight,
          mask: s.mask?.data,
        }

        if (outOfBounds) {
          frontItems.push({ ...obj, x: outOfBounds })
        }
        frontItems.push(obj)
      }
    })

  return {
    name: name,
    items: frontItems,
    backItems,
    size,
  }
}
